export default __webpack_public_path__ + "static/media/a008-5.033c99f0.svg";